import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import ProductMapping from '../../components/ProductMapping/ProductMapping'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const ProductMappingPage = () => {
    return (
        <>
            <Helmet>
                <title>Contract Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <ProductMapping />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ProductMappingPage